import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { ReDirectToeKMC2 } from "../components/ReDirectToeKMC2";

const checklistItemLists = [
  {
    fileStoreId: "e214594d-cbaf-41bc-b8cc-087e2dee5da9",
    label: "EODB WORK FLOW",
  },
  {
    fileStoreId: "35170fd4-4c4b-4554-9a3d-7098e9b4c1e0",
    label: "PROFORMA FOR APPOINTMENT OF TECHNICAL PERSON",
  },
  {
    fileStoreId: "df9a2050-246c-4d20-8d84-89e082fd0327",
    label: "PROFORMA FOR APPOINTMENT OF PLUMBER",
  },
  {
    fileStoreId: "7f24e076-b3de-4489-9696-3da159475c16",
    label: "INSTRUCTION SET FOR CAD DRAWINGS",
  },
  {
    fileStoreId: "8eb81228-0923-4865-ac10-5e4d8b6ab577",
    label: "JOINT SITE INEPECTION FORMAT(CAF1)",
  },
  {
    fileStoreId: "7f1d0b8d-e55e-440e-8369-43a1a06cc1d5",
    label: "JOINT SITE INEPECTION FORMAT(CAF2)",
  },
  {
    fileStoreId: "cbafac57-7c5e-4da7-b0b6-a3eba8f48885",
    label: "IGR- NON INSISTING OF KMC CONSENT",
  },
  {
    fileStoreId: "4b043774-9d38-4484-b366-07319f6a8e09",
    label: "SURVEY ROAD ALIGNMENT",
  },
  {
    fileStoreId: "",
    label: "KMDA ALIGNMENT DRAWINGS",
  },
  {
    fileStoreId: "54cc9410-f7a9-44b5-88ee-3d082a33caf6",
    label: "LIST OF WARDS AFFECTED BY ULCRA",
  },
  {
    fileStoreId: "2ed78e35-86e3-4042-8c76-f843ae0e2d5f",
    label: "STANDARD REASONS OF REJECTIONS",
  },
  {
    fileStoreId: "a7597cad-0789-416d-9308-b2a0edc42957",
    label: "EMAIL IDs OF EXECUTIVE ENGINEERS",
  },
  {
    fileStoreId: "8ffd7d9e-aad4-43c7-8644-c2a75236d136",
    label: "EMAIL IDs OF SURVEY DEPARTMENT",
  },
  {
    fileStoreId: "5977bd71-b359-4ba7-8383-04318199954b",
    label: "EMAIL IDs OF KMDA",
  },
  {
    fileStoreId: "2447a1ac-7bd4-4945-a141-0ec63690cd7f",
    label: "KIT SCHEMES AND ALIGNMENTS",
  },
  {
    fileStoreId: "0ef14aa7-e660-4644-abd1-1fac2f2fa2f7",
    label: "AIRPORT UNDERTAKING FORMAT",
  },
  {
    fileStoreId: "3ee4f54c-5df4-49eb-aa49-439e8e90e0db",
    label: "WEST BENGAL RTPS ACT 2013",
  },
  {
    fileStoreId: "c2a42906-71c6-446d-9eb8-4ad5690af658",
    label: "USER MANUAL",
  },
  {
    fileStoreId: "3e384a0e-f5f6-4769-8d0a-292ea3bf4686",
    label: "FAQ",
  },
  {
    fileStoreId: "8637a3e4-0e6d-448f-bf61-efedd02de27b",
    label: "HOW TO APPLY THROUGH CAF",
  },
  {
    fileStoreId: "e26f86f4-9d7c-4144-94f6-c2a56b450bd3",
    label: "E-UNDERTAKING",
  },
  {
    fileStoreId: "cddac5f2-576e-477c-ba79-ea03cc514a29",
    label: "HOW TO APPLY THROUGH PLINTH LEVEL CAF",
  },
  {
    fileStoreId: "d79f8f86-6028-4d9c-8379-be436283dee5",
    label: "FORMAT FOR PLINTH LEVEL UNDERTAKING",
  },
  {
    fileStoreId: "af7a1af5-a85e-4025-a296-6f8d32d2ebd3",
    label: "UNDERTAKING FOR MOSTLY COVERED PLOT",
  },
  {
    fileStoreId: "deb41655-6b6d-4d90-99f0-36433b58ac73",
    label:
      "UNDERTAKING FOR COMPLIANCE OF GUIDELINES OF PCB, GoWB FOR WASTE WATER GENERATION OR STP",
  },
  {
    fileStoreId: "bf247660-131d-4812-a399-989b83ddf402",
    label: "HOW TO APPLY THROUGH CAF2 (FOR CC & OC)",
  },
  {
    fileStoreId: "119d36ae-2423-4a10-9fc9-6583d6d7f85e",
    label: "INSTRUCTION SET FOR CAD DRAWINGS FOR CC & OC",
  },
  {
    fileStoreId: "ea7e903e-ffa6-49de-a4cf-2c46e59c77a8",
    label: "PROFORMA FOR APPOINTMENT OF TECHNICAL PERSON CAF2 (FOR CC & OC)",
  },
  {
    fileStoreId: "530b9b3f-61ec-4dbe-b40e-5ba22cf79de6",
    label:
      "UNDERTAKING FOR DRAINAGE (NON-SEWER AREA) AND/OR WATER SUPPLY (ALTERNATE SOURCE REQUIRED)",
  },
  {
    fileStoreId: "fcec1682-b490-4b9f-957d-599057674c04",
    label: "UNDERTAKING FOR DRAINAGE FOR BUILT-UP AREA > 5000M",
  },
  //   {
  //     fileStoreId: "",
  //     label: "WARD WISE DRAINAGE NETWORK MAP",
  //   },
];

const Dashboard2 = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      <section className="section inner-pad1 mx-5">
        <div className="container-fluid">
          <h5>{t("EODB DYNAMIC DASHBOARD")}</h5>
          <div className="row">
            <div className="col-lg-12 pb-0 pt-0">
              <div className="desh-bo-2">
                <div id="accordion">
                  <div className="row">
                    <div className="card col-lg-2 p-1">
                      <div className="card-header" id="heading2">
                        <h5 className="mb-0">
                          <button className="btn btn-link collapsed active"
                            data-toggle="collapse" data-target="#collapse2" aria-expanded="false"
                            aria-controls="collapseTwo">
                            {t("Apply")} <i class="bi bi-arrow-right"></i>
                          </button>
                        </h5>
                      </div>
                      <div id="collapse2" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                        <div className="card-body">
                          {t("Apply through Single Window System with user Id")}
                        </div>
                      </div>
                    </div>
                    <div className="card col-lg-2 p-1">
                      <div className="card-header" id="heading3">
                        <h5 className="mb-0">
                          <button className="btn btn-link collapsed active" data-toggle="collapse"
                            data-target="#collapse3" aria-expanded="false"  aria-controls="collapseTwo">
                            {t("Joint Site Inspection")}
                            <i class="bi bi-arrow-right"></i>
                          </button>
                        </h5>
                      </div>
                      <div id="collapse3" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                        <div className="card-body">
                          {t(
                            "KMC and All relevant External Agencies will inspect on a single date and upload JSI report within stipulated time"
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card col-lg-2 p-1">
                      <div className="card-header" id="heading4">
                        <h5 className="mb-0">
                          <button className="btn btn-link collapsed active" data-toggle="collapse"
                            data-target="#collapse4" aria-expanded="false" aria-controls="collapseTwo">
                            {t("NOC")} <i class="bi bi-arrow-right"></i>
                          </button>
                        </h5>
                      </div>
                      <div id="collapse4" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                        <div className="card-body">
                          {t(
                            "KMC and All relevant External Agencies will upload NOC within stipulated time"
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card col-lg-2 p-1">
                      <div className="card-header" id="heading5">
                        <h5 className="mb-0">
                          <button className="btn btn-link collapsed active" data-toggle="collapse" data-target="#collapse5"
                            aria-expanded="false" aria-controls="collapseTwo"> {t("Scrutiny")}
                            <i class="bi bi-arrow-right"></i>
                          </button>
                        </h5>
                      </div>
                      <div id="collapse5" className="collapse show"
                        aria-labelledby="headingTwo" data-parent="#accordion" >
                        <div className="card-body">
                          {t(
                            "After receipt of NOC, Plan case to be scrutinized by Building Department within stipulated time"
                          )}
                          .
                        </div>
                      </div>
                    </div>
                    <div className="card col-lg-2 p-1">
                      <div className="card-header" id="heading6">
                        <h5 className="mb-0">
                          <button className="btn btn-link collapsed active" data-toggle="collapse"
                            data-target="#collapse6" aria-expanded="false" aria-controls="collapseTwo">
                            {t("Process")} <i class="bi bi-arrow-right"></i>
                          </button>
                        </h5>
                      </div>
                      <div id="collapse6" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                        <div className="card-body">
                          {t(
                            "Plan case to be processed under KMC Act 1980 & prevailing KMC Building Rules within stipulated time."
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card col-lg-2 p-1">
                      <div className="card-header" id="heading6a">
                        <h5 className="mb-0">
                          <button className="btn btn-link collapsed active" data-toggle="collapse"
                            data-target="#collapse6a" aria-expanded="false" aria-controls="collapseTwo">
                            {t("Approval/Rejection")}
                            
                          </button>
                        </h5>
                      </div>
                      <div id="collapse6a" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                        <div className="card-body">
                          {t(
                            "Plan case to be approved upon submission of fees / rejected by Standard Reasons of Rejection within stipulated time"
                          )}
                          .
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 pb-0 pt-0">
              <div className="row">
                <div className="col-lg-6 pb-0 pt-0 desh-bo-ser">
                  <div className="card ">
                    <div className="card-header" id="heading7">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed colr1" data-toggle="collapse"
                          data-target="#collapse7" aria-expanded="false" aria-controls="collapseTwo">
                          {t("CHECKLIST")} <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div id="collapse7" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion"
                    >
                      <div className="card-body m-3 des2-list">
                        <ul>
                          {checklistItemLists.map(
                            ({ fileStoreId, label }, index) => (
                              <li key={index}>
                                <DownloadFileByFileStoreId
                                  fileStoreId={fileStoreId}
                                  label={label}
                                  classAdd={false}
                                />
                              </li>
                            )
                          )}
                         
                          <li>
                            <Link to="https://www.kmcgov.in/KMCPortal/jsp/DrainageNetworkMap.jsp" target="_blank">
                              {t( "WARD WISE DRAINAGE NETWORK MAP")}
                            </Link>
                          </li>
                          {/* <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'e214594d-cbaf-41bc-b8cc-087e2dee5da9'}&tenantId=km.kolkata`} target="_blank">{t("EODB WORK FLOW")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'35170fd4-4c4b-4554-9a3d-7098e9b4c1e0'}&tenantId=km.kolkata`}>{t("PROFORMA FOR APPOINTMENT OF TECHNICAL PERSON")} </a> 
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'df9a2050-246c-4d20-8d84-89e082fd0327'}&tenantId=km.kolkata`}>{t("PROFORMA FOR APPOINTMENT OF PLUMBER")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'7f24e076-b3de-4489-9696-3da159475c16'}&tenantId=km.kolkata`}>{t("INSTRUCTION SET FOR CAD DRAWINGS")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'8eb81228-0923-4865-ac10-5e4d8b6ab577'}&tenantId=km.kolkata`}>{t("JOINT SITE INEPECTION FORMAT(CAF1)")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'7f1d0b8d-e55e-440e-8369-43a1a06cc1d5'}&tenantId=km.kolkata`}>{t("JOINT SITE INEPECTION FORMAT(CAF2)")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'cbafac57-7c5e-4da7-b0b6-a3eba8f48885'}&tenantId=km.kolkata`}>{t("IGR- NON INSISTING OF KMC CONSENT")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'4b043774-9d38-4484-b366-07319f6a8e09'}&tenantId=km.kolkata`}>{t("SURVEY ROAD ALIGNMENT")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${''}&tenantId=km.kolkata`}>{t("KMDA ALIGNMENT DRAWINGS")} </a>
                                </li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'54cc9410-f7a9-44b5-88ee-3d082a33caf6'}&tenantId=km.kolkata`}>{t("LIST OF WARDS AFFECTED BY ULCRA")} </a>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'2ed78e35-86e3-4042-8c76-f843ae0e2d5f'}&tenantId=km.kolkata`}>{t("STANDARD REASONS OF REJECTIONS")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'a7597cad-0789-416d-9308-b2a0edc42957'}&tenantId=km.kolkata`}>{t("EMAIL IDs OF EXECUTIVE ENGINEERS")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'8ffd7d9e-aad4-43c7-8644-c2a75236d136'}&tenantId=km.kolkata`}>{t("EMAIL IDs OF SURVEY DEPARTMENT")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'5977bd71-b359-4ba7-8383-04318199954b'}&tenantId=km.kolkata`}>{t("EMAIL IDs OF KMDA")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'2447a1ac-7bd4-4945-a141-0ec63690cd7f'}&tenantId=km.kolkata`}>{t("KIT SCHEMES AND ALIGNMENTS")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'0ef14aa7-e660-4644-abd1-1fac2f2fa2f7'}&tenantId=km.kolkata`}>{t("AIRPORT UNDERTAKING FORMAT")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'3ee4f54c-5df4-49eb-aa49-439e8e90e0db'}&tenantId=km.kolkata`}>{t("WEST BENGAL RTPS ACT 2013")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'c2a42906-71c6-446d-9eb8-4ad5690af658'}&tenantId=km.kolkata`}>{t("USER MANUAL")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'3e384a0e-f5f6-4769-8d0a-292ea3bf4686'}&tenantId=km.kolkata`}>{t("FAQ")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'8637a3e4-0e6d-448f-bf61-efedd02de27b'}&tenantId=km.kolkata`}>{t("HOW TO APPLY THROUGH CAF")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'e26f86f4-9d7c-4144-94f6-c2a56b450bd3'}&tenantId=km.kolkata`}>{t("E-UNDERTAKING")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'cddac5f2-576e-477c-ba79-ea03cc514a29'}&tenantId=km.kolkata`}>{t("HOW TO APPLY THROUGH PLINTH LEVEL CAF")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'d79f8f86-6028-4d9c-8379-be436283dee5'}&tenantId=km.kolkata`}>{t("FORMAT FOR PLINTH LEVEL UNDERTAKING")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'af7a1af5-a85e-4025-a296-6f8d32d2ebd3'}&tenantId=km.kolkata`}>{t("UNDERTAKING FOR MOSTLY COVERED PLOT UNDERTAKING FOR COMPLIANCE OF")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'deb41655-6b6d-4d90-99f0-36433b58ac73'}&tenantId=km.kolkata`}>{t("UNDERTAKING FOR COMPLIANCE OF GUIDELINES OF PCB, GoWB FOR WASTE WATER GENERATION OR STP")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'bf247660-131d-4812-a399-989b83ddf402'}&tenantId=km.kolkata`}>{t("HOW TO APPLY THROUGH CAF2 (FOR CC & OC)")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'530b9b3f-61ec-4dbe-b40e-5ba22cf79de6'}&tenantId=km.kolkata`}>{t("UNDERTAKING FOR DRAINAGE (NON-SEWER AREA) AND/OR WATER SUPPLY (ALTERNATE SOURCE REQUIRED)")} </a>
                                </li>
                                <li>
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'499ad97e-a6e5-4766-a521-1c1314c02646'}&tenantId=km.kolkata`}>{t("UNDERTAKING FOR DRAINAGE FOR BUILT-UP AREA - 5000M")} </a>
                                </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading8">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed colr3"
                          data-toggle="collapse"
                          data-target="#collapse8"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {t("ONLINE BUILDING PERMIT")}
                          <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse8"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 des2-list">
                        <ul>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/BuildingPlanSubmission.jsp"
                              target="_blank"
                            >
                              {t(
                                "COMMON APPLICATION FORM (CAF) FOR BUILDING PERMIT U/S 393A"
                              )}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/BuildingPlanSubmissionStatus.jsp"
                              target="_blank"
                            >
                              {t("BUILDING PLAN DRAWING RE- UPLOAD")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/PlancaseSortfallDoc.jsp"
                              target="_blank"
                            >
                              {t(
                                "BUILDING PLAN SHORTFALL DOCUMENT UPLOAD(BUILDING DEPT.)"
                              )}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/BuildingCafOutSideAgencySortfallDoc.jsp"
                              target="_blank"
                            >
                              {t(
                                "BUILDING PLAN SHORTFALL DOCUMENT UPLOAD(OTHER DEPT.)"
                              )}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/BuildingCafOutSideAgencySortfallView.jsp"
                              target="_blank"
                            >
                              {t(
                                "LIST OF SHORTFALL DOCUMENT REQUIRED(OTHER DEPT.)"
                              )}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/BuildingStrucPlanStatus.jsp"
                              target="_blank"
                            >
                              {t("BUILDING STRUCTURAL DESIGN RE-UPLOAD")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/JSIReport.jsp" target="_blank">
                              {t("JOINT SITE INSPECTION REPORT")}
                            </Link>
                          </li>
                          <li>
                            <Link to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/Dashboard2.jsp" target="_blank">
                              {t("BUILDING SANCTION DOWNLOAD FILES")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/">
                              {t("VIEW NOC FOR BUILDING PERMIT")}
                            </Link>
                          </li>
                          <ul className="des2-list-2">
                            <li>
                              <Link to="/"> {t("KMDA/ KIT")} </Link>
                            </li>
                            <li>
                              <Link to="/"> {t("WBF&ES : FSR Drawing")} </Link>
                            </li>
                            <li>
                              <Link to="/"> {t("WBF&ES : FSR Document")} </Link>
                            </li>
                            <li>
                              <Link to="/"> {t("NMA")} </Link>
                            </li>
                            <li>
                              <Link to="/"> {t("AAI")} </Link>
                            </li>
                            <li>
                              <Link to="/"> {t("WBPCB")} </Link>
                            </li>
                            <li>
                              <Link
                                to="https://www.kmcgov.in/KMCPortal/jsp/WaterSupplySanctionOrderForCAF.jsp"
                                target="_blank"
                              >
                                {t("WATER SUPPLY SANCTION ORDER (Form II)")}
                              </Link>
                            </li>
                            <li>
                              <Link to="/">
                                {t("ENGINEERING/ DRAINAGE, KMC")}
                              </Link>
                            </li>
                            <li>
                              <Link to="/">
                                {t("SURVEY OBSERVATION REPORT, KMC")}
                              </Link>
                            </li>
                            <li>
                              <Link to="/">
                                {t("ULC APPLICATION STATUS & NOC DOWNLOAD")}
                              </Link>
                            </li>
                            <li>
                              <Link to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/Dashboard2.jsp"> 
                              {t("MBC RESOLUTION, KMC")} </Link>
                            </li>
                            <li>
                              <Link to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/Dashboard2.jsp">
                                {t("THIKA OBSERVATION REPORT")}
                              </Link>
                            </li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading9">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed colr4"
                          data-toggle="collapse"
                          data-target="#collapse9"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {t("CITIZEN SEARCH")}
                          <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse9"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 des2-list">
                        <ul>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/PlanProposalStatus.jsp"
                              target="_blank"
                            >
                              {t("SANCTION STATUS BY PLANCASE NO")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/PlancaseInformationSearch.jsp"
                              target="_blank"
                            >
                              {t(
                                "SANCTION STATUS BY ASSESSEE NO OR WARD,STREET,PREMISE NO"
                              )}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/ULCApplicationStatus.jsp"
                              target="_blank"
                            >
                              {t("ULC APPLICATION STATUS")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/BuildingEODBPlanCaseSearch.jsp"
                              target="_blank"
                            >
                              {t("EODB SANCTION LIST")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/KMCFeesCalculationAction.do"
                              target="_blank"
                            >
                              {t("ONLINE FEE CALCULATOR")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/">
                              {t("CONSOLIDATED DEMAND FOR BUILDING PERMIT")}
                            </Link>
                          </li>
                          <ul className="des2-list-2">
                            <li>
                              <Link
                                to="https://www.kmcgov.in/KMCPortal/jsp/CafNocPaymentHome.jsp"
                                target="_blank"
                              >
                                {t("EXTERNAL AGENCIES")}
                              </Link>
                            </li>
                            <li>
                              <Link to="/"> {t("KMC DEPARTMENTS")} </Link>
                            </li>
                          </ul>
                          <ul className="des2-list-3">
                            <li>
                              <Link
                                to="https://www.kmcgov.in/KMCPortal/jsp/BuildingEodbDemandPrint.jsp"
                                target="_blank"
                              >
                                {t("DEMAND PRINT")}
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingPayment.jsp"
                                target="_blank"
                              >
                                {t("MAKE PAYMENT")}
                              </Link>
                            </li>
                          </ul>
                          <li>
                            <Link to="/">
                              {t("RECEIPT OF PAYMENT FOR BUILDING PERMIT")}
                            </Link>
                          </li>
                          <ul className="des2-list-2">
                            <li>
                              <Link
                                to="https://www.kmcgov.in/KMCPortal/jsp/CafDuplicateReceipt.jsp"
                                target="_blank"
                              >
                                {t("EXTERNAL AGENCIES")}
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingReceiptReprint.jsp"
                                target="_blank"
                              >
                                {t("KMC DEPARTMENTS")}
                              </Link>
                            </li>
                          </ul>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingEODBCAF2SanctionStatus.jsp"
                              target="_blank"
                            >
                              {t("CC APPLICATION STATUS BY CC CASE NUMBER")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/">
                              {t("CONSOLIDATED DEMAND FOR CC & OC")}
                            </Link>
                          </li>
                          <ul className="des2-list-2">
                            <li>
                              <Link to="/"> {t("EXTERNAL AGENCIES")} </Link>
                            </li>
                            <li>
                              <Link to="/"> {t("KMC DEPARTMENTS")} </Link>
                            </li>
                          </ul>
                          <ul className="des2-list-3">
                            <li>
                              <Link
                                to="https://www.kmcgov.in/KMCPortal/jsp/BuildingDemandPrint.jsp"
                                target="_blank"
                              >
                                {t("DEMAND PRINT")}
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingPayment.jsp"
                                target="_blank"
                              >
                                {t("MAKE PAYMENT")}
                              </Link>
                            </li>
                          </ul>
                          <li>
                            <Link to="/">
                              {t(
                                "RECEIPT OF PAYMENT FOR CC& OC (UNDER DEVELOPMENT)"
                              )}
                            </Link>
                          </li>
                          <ul className="des2-list-2">
                            <li>
                              <Link to="/"> {t("EXTERNAL AGENCIES")} </Link>
                            </li>
                            <li>
                              <Link to="/"> {t("KMC DEPARTMENTS")} </Link>
                            </li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading14">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed colr5"
                          data-toggle="collapse"
                          data-target="#collapse14"
                          aria-expanded="false"
                          aria-controls="collapseTwo">
                          {t("ONLINE PLINTH LEVEL INTIMATION")}
                          <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div id="collapse14" className="collapse"
                      aria-labelledby="headingTwo" data-parent="#accordion">
                      <div className="card-body m-3 des2-list">
                        <ul>
                          <li>
                            <Link to="https://www.kmcgov.in/KMCPortal/jsp/BuildingPlinthCmplDeclaration.jsp"
                              target="_blank">
                              {t( "COMMON APPLICATION FORM (CAF) FOR PLINTH LEVEL PERMISSION")}
                            </Link>
                          </li>
                          <li> <Link to="/"> {t("PLINTH LEVEL INSPECTION REMARKS")} </Link> </li>
                          <li> <Link to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/BuildingPlinthSortfall.jsp"> 
                          {t("PLINTHCASE SHORTFALL DOCUMENTS REUPLOAD")} </Link> </li>
                          <li> <Link to="/"> {t("VIEW NOC")} </Link></li>
                          <li> <Link to="/"> {t("WBPCB")} </Link> </li>
                        </ul>
                        
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading15">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed colr6"
                          data-toggle="collapse"
                          data-target="#collapse15"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {t("REFORMS")} <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse15"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 des2-list">
                        <ul>
                          <li>
                            <Link to="/"> {t("EODB Circulars")} </Link>
                          </li>
                          <li>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"3d0f2711-dd28-4a5d-b5b3-234360069344"}&tenantId=km.kolkata`}
                            >
                              {t("RTPSA")}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 pb-0 pt-0 desh-bo-ser">
                  <div className="card">
                    <div className="card-header" id="heading10">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed colr2"
                          data-toggle="collapse"
                          data-target="#collapse10"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {t("RELATED LINKS")}
                          <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse10"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 des2-list">
                        <ul>
                          <li>
                            <Link
                              to="https://nocas2.aai.aero/nocas/CCZMPage.html"
                              target="_blank"
                            >
                              {t("CCZM OF AAI")}
                            </Link>
                          </li>
                          <li>
                            <Link to="https://igbc.in/igbc/" target="_blank">
                              {t("IGBC")}
                            </Link>
                          </li>
                          <li>
                            <Link to="http://kmdaonline.org/" target="_blank">
                              {t("KMDA/ KIT")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.wb.gov.in/404-page.aspx?aspxerrorpath=/departments-fire-and-emergency-services.aspx"
                              target="_blank"
                            >
                              {t("WBF&ES")}
                            </Link>
                          </li>
                          <li>
                            <Link to="http://www.nma.gov.in/" target="_blank">
                              {t("NMA")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://wbpower.gov.in/directorate-officersstiregulatory-authorities/"
                              target="_blank"
                            >
                              {t("DIRECTORATE OF ELECTRICITY")}
                            </Link>
                          </li>
                          <li>
                            <Link to="http://www.wbpcb.gov.in/" target="_blank">
                              {t("WBPCB")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://wbregistration.gov.in/(S(k2d1j24tycgxxuykzoxaiego))/index.aspx"
                              target="_blank">
                              {t("DIRECTORATE OF REGISTRATION & STAMP REVENUE")}
                            </Link>
                          </li>
                          <li>
                            <Link to="https://www.wburbanservices.gov.in/" target="_blank">
                              {t("UD&MA")}
                            </Link>
                          </li>
                          <li>
                            <Link to="https://ulcudma.wb.gov.in/" target="_blank">
                              {t("ULC Link")}
                            </Link>
                          </li>

                          <li>
                            <DownloadFileByFileStoreId
                              fileStoreId={"22ef0c56-ef81-46c2-ada9-32bb8f9fb145"}
                              label={"User Manual for ULC Online Application"}
                              classAdd={false}/>
                          </li>
                          <li>
                            <DownloadFileByFileStoreId
                              fileStoreId={ "394a1bbc-5c50-4a49-b7ee-68ccc70bcc7a"}
                              label={"GUIDELINES FOR APPLICANTS FOR NOC APPLICATION IN NOCAS"}
                              classAdd={false}/>
                          </li>
                          <li>
                            <Link to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/ThikaNocPendingList.jsp" target="_blank">
                              {t("NOC for Thika Controller")}
                            </Link>
                          </li>

                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading11">
                      <h5 className="mb-0">
                        <button className="btn btn-link collapsed colr7"
                          data-toggle="collapse" data-target="#collapse11" aria-expanded="false" aria-controls="collapseTwo">
                          {t("ONLINE CC & OC")}
                          <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div id="collapse11" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                      <div className="card-body m-3 des2-list">
                        <ul>
                          <li>
                            <Link to="/">
                              {t("COMMON APPLICATION FORM (CAF) FOR CC& OC")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingEODBCAF2ShortfallDetails.jsp"
                              target="_blank"
                            >
                              {t("LIST OF SHORTFALL DOCUMENT(S) REQUIRED")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingEODBCAF2ShortfallUpload.jsp"
                              target="_blank"
                            >
                              {t("BUILDING PLAN SHORTFALL DOCUMENT(S) UPLOAD")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingEODBCAF2DrawingReupload.jsp"
                              target="_blank"
                            >
                              {t("CAD DRAWING RE- UPLOAD")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingEODBCAF2JSIDetails.jsp"
                              target="_blank"
                            >
                              {t("JOINT SITE INSPECTION DETAILS")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/"> {t("VIEW NOC FOR CC&OC")} </Link>
                          </li>
                          <li>
                            <Link to="/"> {t("WBF&ES")} </Link>
                          </li>
                          <li>
                            <Link to="/">
                              {t("FORM C (DIRECTORATE OF ELECTRICITY)")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/"> {t("WBPCB")} </Link>
                          </li>
                          <li>
                            <Link to="/"> {t("WATER SUPPLY/ KMC")} </Link>
                          </li>
                          <li>
                            <Link to="/"> {t("ENGINEERING/ DRIANAGE, KMC")} </Link>
                          </li>
                          <li>
                            <Link to="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/KMCBuildingEODBCAF2CCOCDownload.jsp"> 
                            {t("DIGITALLY SIGNED CC-OC CERTIFICATE DOWNLOAD")} </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading12">
                      <h5 className="mb-0">
                        <button className="btn btn-link collapsed colr8" data-toggle="collapse"
                          data-target="#collapse12" aria-expanded="false" aria-controls="collapseTwo">
                          {t("MISCELLENEOUS")}
                          <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div id="collapse12" className="collapse" aria-labelledby="headingTwo"
                      data-parent="#accordion">
                      <div className="card-body m-3 des2-list">
                        <ul>
                          <li>
                            {/* <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"c49c30f4-0935-4d07-9014-e952cb0a4ea0"}&tenantId=km.kolkata`}
                            >
                              {t(
                                "Construction of Buiilding Permit (As per Minicipal Commissioner's Circilar No : 12 of 2021-2022) [Empowerment of Technical Professionals for according sanction of Low Risk Buildings under EoDB Costruction Permit]"
                              )}
                            </a> */}
                            <DownloadFileByFileStoreId
                              fileStoreId={
                                "ff8309cc-7cb9-4031-b830-a1946f72cb0b"
                              }
                              label={
                                "Construction of Buiilding Permit (As per Minicipal Commissioner's Circilar No : 12 of 2021-2022) [Empowerment of Technical Professionals for according sanction of Low Risk Buildings under EoDB Costruction Permit]"
                              }
                              classAdd={false}
                            />
                          </li>
                          <li>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"6dc64803-f1ba-497b-b9cf-5cded8eaf312"}&tenantId=km.kolkata`}
                            >
                              {t(
                                "HOW TO APPLY THROUGH CAF VIDE MCS CIR. NO. 12"
                              )}
                            </a>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/BuildingPlanSubmissionSpl.jsp"
                              target="_blank"
                            >
                              {t(
                                "APPLICATION FOR CONSTRUCTION OF BUILDING PERMIT"
                              )}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/DrawingDataView.jsp"
                              target="_blank"
                            >
                              {t("VIEW DRAWING DATA")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/BlockWiseReport.jsp"
                              target="_blank"
                            >
                              {t("BLOCKWISE SUMMARY REPORT")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/BuildingInfringementProcess.jsp"
                              target="_blank"
                            >
                              {t("INFRINGEMENT PROCESS")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/BuildingDemandScreen.jsp"
                              target="_blank"
                            >
                              {t("DEMAND GENERATION")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingPayment.jsp"
                              target="_blank"
                            >
                              {t("PAYMENT")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.kmcgov.in/KMCPortal/jsp/BuildingSanctionProcess.jsp"
                              target="_blank"
                            >
                              {t("SANCTION")}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading13">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed colr9"
                          data-toggle="collapse"
                          data-target="#collapse13"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {t("ALERT NOTICE")}
                          <i className="bi bi-chevron-down" />
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse13"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 des2-list">
                        <ul>
                          <li>
                            {t(
                              "The CCZM of Kolkata is not currently available on NOCAS due to revition process and the same will be available shortly as par notificition available in http:// nocas2.aai.aero/nocas/ Therefore for application made through EoDB, if your proposal attracts CCZM, you are required to approach directly to Airport Authority of India to obtain NOC for height clearance from AAI. This mechanism will continue till the issue is resolved"
                            )}
                            .
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard2;
